import { isCrashed } from './Crashing';
import { API_SERVER } from '../../helpers/URLs';
import { isLoading } from './Loading';

export const SUCCESS_GET_VEHICULOS_CAT = "SUCCESS_GET_VEHICULOS_CAT";
export const FAILED_GET_VEHICULOS_CAT = "FAILED_GET_VEHICULOS_CAT";


export const successGetVehiculosCat = categoriasVehiculosCat => ({
    type: SUCCESS_GET_VEHICULOS_CAT,
    categoriasVehiculosCat
})

export const failedGetVehiculosCat = () => ({
    type: FAILED_GET_VEHICULOS_CAT
})

export const fetchVehiculosCatalogo = () => {
    return dispatch => {

        fetch(`${API_SERVER}/Interamerican/Vehiculos/Categoria?SoloCategorias=false`, {
            method: 'get',
            headers: {
                "Content-Type": "application/json"
            },
            mode:'cors'
        })
            .then(response => {
                const data = response.json();
               
                if (!response.ok) {
                    const error = (data && data.message) || response.status;
                    dispatch(isLoading(false))
                    dispatch(isCrashed(true))
                    console.error(error)
                    return Promise.reject(error);
                }

                return data
            })
            .then(response => dispatch(successGetVehiculosCat(response)))
            .catch(error => {
                dispatch(isLoading(false))
                dispatch(isCrashed(true))
                dispatch(failedGetVehiculosCat())
            });
    }
}

